import { useState } from "react";

/** Props for a dialog that opens from its own button or from outside it. */
export interface ControlledDialogProps {
  /** Set to control the dialog from outside (the + New menu); hides its own button. */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/**
 * Open state for the create dialogs (W12 U1): their own button by default,
 * or the caller's `open` / `onOpenChange` when given.
 */
export function useDialogState({ open, onOpenChange }: ControlledDialogProps) {
  const [ownOpen, setOwnOpen] = useState(false);
  const isControlled = open !== undefined;
  return {
    isOpen: isControlled ? open : ownOpen,
    setIsOpen: (next: boolean) =>
      isControlled ? onOpenChange?.(next) : setOwnOpen(next),
    showTrigger: !isControlled,
  };
}
